var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M44 76C61.6731 76 76 61.6731 76 44C76 26.3269 61.6731 12 44 12C26.3269 12 12 26.3269 12 44C12 61.6731 26.3269 76 44 76Z","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M84 84L66.8 66.8","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Search.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Search;

Search.default = Search;
